"use client"

import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { selectLanguage, selectUser } from "@/app/redux/store"

import ProjectCard from "../project-card/project-card"
import Label from "../label/Label"
import { getAllCurrentsProjectsByType, getAllUsersByPartner, getLabels, getPartner } from "@/app/adapters/api"
import { GridSkeleton } from "../../skeleton/gridSkeleton"
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button"
import Link from "next/link"

const labelsNames = [
  "home-testimonies-title-1", 
  "home-testimonies-title-2", 
  "home-testimonies-charge-1", 
  "home-testimonies-charge-2", 
  "home-testimonies-quote-1", 
  "home-testimonies-quote-2", 
  "home-testimonies-text-1", 
  "home-testimonies-text-2", 
]

export default function HomeTestimonies({
    labels,
  }: {
    labels: any;
  }) {

  const lang = useSelector(selectLanguage)

  return (
    <section className="bg-[#FCF6F0]">
        <>
          <div className="px-10 py-8 md:px-24 md:py-16 max-w-[1200px] mx-auto h-auto pb-4 flex flex-row max-[1200px]:flex-col justify-center items-center gap-4 md:gap-12">
            <div className="rounded-xl md:w-[750px] w-[95%] h-auto flex flex-col md:flex-row justify-center items-center bg-white shadow-lg">
              <div className="w-full md:w-[50%] h-[350px] md:h-[500px] rounded-xl bg-white bg-cover bg-no-repeat bg-top md:bg-center" style={{ backgroundImage: `url('/images/jokin.png')` }}>
              
              </div>
              <div className="w-full md:w-[55%] h-[full] flex flex-col items-start gap-5 py-6 px-6">
                <h3 className="text-2xl text-[#F8B361]">
                  {labels.homeTestimoniesTitle1}
                  </h3>
                <p className="text-base text-[#F8B361] leading-4">
                  {labels.homeTestimoniesCharge1}
                </p>
                <p className="text-xl text-black font-bold leading-6">
                  {labels.homeTestimoniesQuote1}
                </p>
                <p className="text-xl text-black leading-6">
                  {labels.homeTestimoniesText1}
                </p>
                <Link href='https://www.youtube.com/watch?v=qBL09UcaQIE' target='_blank'>
                  <Button variant={"orange"} className="px-8">
                    {lang === 'en' ? 'Go to video' : 'Ir al vídeo'}
                  </Button>
                </Link>
              </div>
            </div>

            <div className="rounded-xl md:w-[750px] w-[95%] h-auto flex flex-col md:flex-row justify-center items-center bg-white shadow-lg">
              <div className="w-full md:w-[50%] h-[350px] md:h-[500px] rounded-xl bg-white bg-cover bg-no-repeat bg-top md:bg-center" style={{ backgroundImage: `url('/images/teresa.png')` }}>
              
              </div>
              <div className="w-full md:w-[55%] h-[full] flex flex-col items-start gap-5 py-6 px-6">
                <h3 className="text-2xl text-[#F8B361]">
                  {labels.homeTestimoniesTitle2}
                </h3>
                <p className="text-base text-[#F8B361] leading-4">
                 {labels.homeTestimoniesCharge2}
                </p>
                <p className="text-xl text-black font-bold leading-6">
                  {labels.homeTestimoniesQuote2}
                </p>
                <p className="text-xl text-black leading-6">
                  {labels.homeTestimoniesText2}
                </p>
                <Link href='https://www.youtube.com/watch?v=khgiTahO0d0' target='_blank'>
                  <Button variant={"orange"} className="px-8">
                    {lang === 'en' ? 'Go to video' : 'Ir al vídeo'}
                  </Button>
                </Link>
              </div>
            </div>

          </div>
        </>
    </section>
  )
}
